/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Substation_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} substation" |
* | "other" | "{count} substations" |
*
* @param {Substation_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const substation_count = /** @type {((inputs: Substation_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Substation_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} substation`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} substations`);
		return /** @type {LocalizedString} */ ("substation_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} sous-station`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} sous-stations`);
		return /** @type {LocalizedString} */ ("substation_count");
	}
});